(function() {
	window.FQ = (function()
	{
		function FQ() {}

		FQ.api_url = "http://app-sp.webkul.com/product-faq/";

		FQ.insertHtml = function(template)
		{
			
			// console.log(template);
			//console.log('template end');
			var product_dom = $("#wk_product_faq");           
			product_dom.html(template);
		};

		FQ.faqFunc = function(faq_config, faq_details)
		{
			var heading_color = faq_config['heading_text_color'];
			var heading_font_size = faq_config['heading_font_size'];
			var heading_font_family = faq_config['heading_font_family'];
			var border_color = faq_config['border_color'];
			var back_color = faq_config['background_color'];
			var text_color = faq_config['text_color'];
			var text_font_size = faq_config['text_font_size'];
			var text_font_family = faq_config['text_font_family'];

			var html = '<style type="text/css">#wk_product_faq .ui-helper-reset {font-size:14px;}#wk_product_faq .ui-accordion .ui-accordion-header{color:' +heading_color+ ' !important;font-family:' +heading_font_family+ ' !important;font-size:' +heading_font_size+ 'px!important;}#wk_product_faq .ui-accordion .ui-accordion-content { color:' +text_color+ ' !important;font-family:' +text_font_family+ ' !important;font-size:' +text_font_size+ 'px!important}#wk_product_faq .ui-state-active,#wk_product_faq .ui-widget-content .ui-state-active,#wk_product_faq .ui-widget-header .ui-state-active {border:1px solid #000000!important}#wk_product_faq .ui-state-default,#wk_product_faq .ui-widget-content .ui-state-default,#wk_product_faq .ui-widget-header .ui-state-default {background: none repeat-x scroll 50% 50% ' +back_color+ '!important;}#wk_product_faq .ui-widget-content {border-left:1px solid ' +border_color+ '!important;border-bottom:1px solid ' +border_color+ '!important;border-right:1px solid ' +border_color+ '!important;}</style>';
      
			html += '<div class="product_faq" id="faq_detail_div">';

		
			$.each(faq_details, function(i, value)
			{
				html = html + '<h4><span>' + value["faq_title"] + '</span></h4>';

				html = html + '<div>' + value["faq_description"] + '</div>';

			});

			html +='</div>';

			//template = html.replace(/(?:\\[rn]|[\r\n]+)+/g, "<br />");
			FQ.insertHtml(html);


			$( "#faq_detail_div" ).accordion({
				event: "click hoverintent",
				heightStyle: "content"
			});
		};

		FQ.shopifyFaq = function()
		{
          
			FQ.product_id = $('#wk_product_faq').data('product-id')
			if(FQ.product_id == 'undefined')
				FQ.product_id = '';

			return FQ.$.ajax
			({
				url: "" + FQ.api_url + "index.php?p=shopify_faq_script",
				type: "GET",
				async: true,
				// jsonpCallback: 'jsonCallback',
				contentType: "application/json",
				dataType: "jsonp",
				data: {prod_handle: FQ.product_handle, shop_name : FQ.shop_name, prod_id:FQ.product_id},
				success: function(data)
				{
					// data = $.parseJSON(data);
					var faq_config = data['faq_config'];
					var product_faq = data['pro_faq'];
					// console.log(pro_faq['store_name']);

					FQ.faqFunc(faq_config, product_faq);
				},
				error: function(xhr, ajaxOptions, thrownError)
				{
					console.log(xhr.status);
					console.log(thrownError);
				}
			});
		};

		FQ.loadjQuery = function(afterLoad)
		{
			return FQ.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js", function()
			{
			FQ.$ = jQuery.noConflict(true);
			return afterLoad();
			});
		};

		FQ.loadjQueryDependency = function(url,afterLoadDependency)
		{
			return FQ.loadScript(url, function()
			{
			// FQ.$ = jQuery.noConflict(true);
			return afterLoadDependency();
			});
		};

		FQ.loadjStyleDependency = function(url,afterLoadStyleDependency)
		{
			return FQ.loadScript(url, function()
			{
			// FQ.$ = jQuery.noConflict(true);
			return afterLoadStyleDependency();
			});
		};

		FQ.loadScript = function(url, callback)
		{
			var script;
			script = document.createElement("script");
			script.type = "text/javascript";

			if (script.readyState)
			{
				script.onreadystatechange = function()
				{
					if (script.readyState === "loaded" || script.readyState === "complete")
					{
						script.onreadystatechange = null;
						return callback();
					}
				};
			}
			else
			{
				script.onload = function()
				{
					return callback();
				};
			}

			script.src = url;
			return document.getElementsByTagName("head")[0].appendChild(script);
		};


		FQ.loadStyle = function(url, callback)
		{
			var stylesh;
			stylesh = document.createElement("style");
			stylesh.type = "text/css";
			stylesh.media = "all";
			stylesh.rel = "stylesheet";

			if (stylesh.readyState)
			{
				stylesh.onreadystatechange = function()
				{
					if (stylesh.readyState === "loaded" || stylesh.readyState === "complete")
					{
						stylesh.onreadystatechange = null;
						return callback();
					}
				};
			}
			else
			{
				stylesh.onload = function()
				{
					return callback();
				};
			}

			stylesh.src = url;
			return document.getElementsByTagName("head")[0].appendChild(stylesh);
		};


		return FQ;

	})();
  


  
	FQ.path = window.location.pathname.split('/');

	FQ.product_path = FQ.path[1] === 'products';

	FQ.product_handle = FQ.path[2];

	FQ.shop_name = Shopify.shop;

	if (FQ.product_path)
	{
		FQ.loadjQuery(function()
		{
          
          return FQ.shopifyFaq();
          
			FQ.$.ajaxSetup({
				cache: false
			});
			FQ.loadjQueryDependency('//shopify.webkul.com/shopify/js/accordion/jquery.ui.core.js',function()
			{
              
				FQ.loadjQueryDependency('//shopify.webkul.com/shopify/js/accordion/jquery.ui.widget.js',function()
				{
					FQ.loadjQueryDependency('//shopify.webkul.com/shopify/js/accordion/jquery.ui.accordion.js',function()
					{
                     
						return FQ.shopifyFaq();
					});
				});
			});

		});
	}
	else
	{
		FQ.product_path = FQ.path[3] === 'products';
		FQ.product_handle = FQ.path[4];
		if (FQ.product_path)
		{
			FQ.loadjQuery(function()
			{
				FQ.$.ajaxSetup({
					cache: false
				});
				FQ.loadjQueryDependency('//shopify.webkul.com/shopify/js/accordion/jquery.ui.core.js',function()
				{
					FQ.loadjQueryDependency('//shopify.webkul.com/shopify/js/accordion/jquery.ui.widget.js',function()
					{
						FQ.loadjQueryDependency('//shopify.webkul.com/shopify/js/accordion/jquery.ui.accordion.js',function()
						{
                           console.log(FQ.product_path);
 
							return FQ.shopifyFaq();
						});
					});
				});

			});
		}
	}

}).call(this);